export default __webpack_public_path__ + "static/media/4-2.e99c7a46.mp3";